import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Box = styled.div<{ $hasBottomMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? '15px' : '0'};
`;

export const Title = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  margin-bottom: 10px;
`;
